import FlagsProvider from './component'
export default FlagsProvider
